import styled from 'styled-components';
import tw from 'twin.macro';
import Button from '../Button/Button';
import { Title } from '../../styled components/Typography';
import { UIBar } from '../../styled components/UIBar';
import UICard from '../../styled components/UICard';

export const StyledCard = styled(UICard).attrs((props) => ({
  className: props.classes
}))(({ $disabled }) => [
  /* min-w-0: Flex hack to have the cards content break-words to work when the card is in a flex container.
     If not applied the long strings inside the content of the card will break the width of the card and of the viewport. */
  tw`min-w-0`,
  $disabled && tw`opacity-50 pointer-events-none`
]);

export const CardBullet = styled.div(() => [
  tw`block w-8 h-8 rounded-full bg-blue-base absolute`,
  tw`-mt-4 -ml-4`
]);

export const CardExpandButtonContainer = styled.div(({ $rotated }) => [
  tw`absolute top-1/2 left-0 transform -translate-y-1/2 transition-transform duration-100 ease-in-out`,
  $rotated ? tw`-rotate-90` : tw`rotate-0`
]);

export const CardContentContainer = styled.div(({ $visible }) => [
  tw`p-0 overflow-hidden`,
  $visible ? tw`h-auto` : tw`h-0`
]);

export const CardHeader = styled.div(() => [tw`relative flex pl-32 my-8 mx-4`]);

export const CardHeaderButton = styled.button.attrs(() => ({
  tabIndex: '-1'
}))(() => [
  tw`border-0 m-0 p-0 cursor-pointer relative w-full flex items-center justify-center align-middle no-underline bg-transparent rounded-none select-none appearance-none whitespace-nowrap`
]);

export const CardHeaderActionContainer = styled.div(() => [
  tw`absolute right-0 top-1/2 transform -translate-y-1/2`
]);

export const StyledLockButton = styled(Button).attrs(() => ({
  contentType: 'icon',
  icon: 'lock-closed',
  size: 'medium'
}))(() => [tw`text-cyan-base hover:text-cyan-base`]);

export const CardAnnotationText = styled(Title).attrs(() => ({
  as: 'h3'
}))(({ $color }) => [
  tw`ml-4`,
  $color === 'red' && tw`text-red-darken-20`,
  $color === 'cyan' && tw`text-cyan-darken-10`
]);

export const CardUIBar = styled(UIBar)(({ $hasPencilOrLock }) => [
  $hasPencilOrLock && tw`pr-40`,
  !$hasPencilOrLock && tw`mr-8`
]);
